import React, { Component } from 'react'

import chevron from '../../assets/chevron-thin-down.svg'
import { Wrap, Label, StyledSelect } from './styles'

class Select extends Component {
  render() {
    const { label, value, handleChange, name, dataKey, options } = this.props

    return (
      <Wrap>
        {label ? <Label>{label}</Label> : null}

        <StyledSelect defaultValue={value} onChange={handleChange} name={name} data-key={dataKey} chevron={chevron}>
          {options.map((option, index) => {
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            )
          })}
        </StyledSelect>
      </Wrap>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js